"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsFurniture = void 0;
const useModelsQuery_1 = require("./useModelsQuery");
function useModelsFurniture(accountNumber) {
    return useModelsQuery_1.useModelsQuery('/furniture', accountNumber);
}
exports.useModelsFurniture = useModelsFurniture;
//# sourceMappingURL=useModelsFurniture.js.map